export const WIN_MESSAGES = ['Ya dancer!', 'Peesie!', 'Braw!']
